import Chart from "react-apexcharts";
import { background, primary, text } from "../../theme";
import { useGlobal } from "../../hooks/global";

export const StatusLineChart = ({ chartTemporalData }: { chartTemporalData?: any }) => {
  const { theme } = useGlobal()

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "line",
      height: 400,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    
    title: {
      text: "Evolução das Acomodações por Status",
      align: "left",
      offsetY: 10,
      style: {
        fontSize: "14px",
        fontFamily: "poppins",
        
        color: text[theme],
      },
    },
    xaxis: {
      categories: chartTemporalData?.name,
    },
    fill: {
    },
    /* grid: {
      row: {
        colors: ['#f3f3f3', ], // takes an array which will be repeated on columns
        opacity: 0.5
      },

    }, */
  };
  return (
    <div style={{ width: "100%", height: "100%" }}>
      {chartTemporalData && (
        <div className="app">
          <Chart options={options} style={{ background: primary[theme] }} series={chartTemporalData?.datasets} type="line" height={350} />
        </div>
      )}
    </div>
  );
};
